import { ReactElement, useCallback, useMemo } from 'react';
import { useFollowIssuesOnMap } from 'store/issue';
import { CommonTranslationKeys } from 'intl/keys';
import { MemoTableAnchor } from 'components/tableAnchor';
import { DocumentationDataGrid } from 'components/documentation/DocumentationDataGrid/index';
import { TableAnchorHeader } from 'components/tableAnchor/types';
import { DocumentationCreateMenu } from 'components/documentation/DocumentationCreateButton';
import { DocumentationSearchInput } from 'components/documentation/DocumentationSearchInput';
import { DirectoryDialog } from '../directory/dialog';
import {
  useDocumentationUrlControl,
} from './model';
import { DocumentationBreadcrumbs } from 'components/documentation/DocumentationBreadcrumbs';
import { withProjectChangeDialog } from 'components/common/withProjectChangeDialog';
import { withProcessesData } from 'components/common/withProcessesData';
import { WithDataGridApi } from 'components/common/withDataGridApi';
import { DocumentationDataGridActions } from 'components/documentation/DocumentationDataGrid/components/DocumentationDataGridActions';
import { useDocumentationInitializer } from 'store/documentation';

function _Documentations(): ReactElement {
  useDocumentationInitializer();
  useFollowIssuesOnMap();
  useDocumentationUrlControl();

  const documentationCreatePermission = useCallback(() => {
    return { permission: true };
  }, []);
  const creationAction = useCallback(() => {
    return;
  }, []);
  const documentationHeader: TableAnchorHeader = useMemo(() => {
    return {
      id: 'documentation-header',
      textId: CommonTranslationKeys.add,
      dataQaId: 'documentation_create_button',
    };
  }, []);

  return (
    <WithDataGridApi>
      <MemoTableAnchor
        canCreate={documentationCreatePermission}
        creationAction={creationAction}
        TableComponent={DocumentationDataGrid}
        loading={false}
        headerWithCreation={documentationHeader}
        CreationComponent={DocumentationCreateMenu}
        SearchInput={DocumentationSearchInput}
        DataGridActions={DocumentationDataGridActions}
      >
        <DocumentationBreadcrumbs />
      </MemoTableAnchor>
      <DirectoryDialog />
    </WithDataGridApi>
  );
}
export const Documentations = withProcessesData(
  withProjectChangeDialog(_Documentations)
);
